import * as PropertyBucket from '../../Properties/Properties';
import * as httpService from '../../Components/HttpService/HttpService';

export function getModesDataRequested() {
    return {
        type: 'GET_MODES_DATA_REQUESTED'
    };
}

export function getModesDataDone(data) {
    return {
        type: 'GET_MODES_DATA_DONE',
        payload: data
    };
}

export function getModesDataFailed(error) {
    return {
        type: 'GET_MODES_DATA_FAILED',
        payload: error
    };
}

export function getModesData() {
    let url = PropertyBucket.getModes();
    return dispatch => {
        dispatch(getModesDataRequested());
        let response = httpService.getService(url, "GET");
            response.then(data => {
                dispatch(getModesDataDone(data));
            })
            .catch(error => {
                dispatch(getModesDataFailed(error));
            })
    }
}

export const GET_MODES_DATA_REQUESTED = 'GET_MODES_DATA_REQUESTED';
export const GET_MODES_DATA_DONE = 'GET_MODES_DATA_DONE';
export const GET_MODES_DATA_FAILED = 'GET_MODES_DATA_FAILED';